<template>
  <div class="charts-page">
    <div class="row topCardGrid">
      <sp-card :valor="totalEmpresasUltimoMes" :descricao="$t('empreenda.ccm.tituloCardEmpresasEmpreendaMes')" :lgGrid="3" :footerText="ref"/>
      <sp-card :valor="totalEmpresasUltimoSemestre" :descricao="$t('empreenda.ccm.tituloCardEmpresasEmpreendaSemestre')" :lgGrid="3" :footerText="ref"/>
      <sp-card :valor="totalEmpresasUltimoAno" :descricao="$t('empreenda.ccm.tituloCardEmpresasEmpreendaAno')" :lgGrid="3" :footerText="ref"/>
      <sp-card :valor="totalEmpresasDesdeSempre" :descricao="$t('empreenda.ccm.tituloCardEmpresasEmpreendaDesdeSempre')" :lgGrid="3" :footerText="ref"/>
    </div>

    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel :title="`${tabela.titulo} - ${corteTemporalEscolhido.label}`" :tooltipOptions="tabela.topTooltipOptions" :footerText="ref">
          <div class="flex-box" >
            <!--div class="flex md4">
              <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="" :habilitarAnimacaoClique="true"></sp-map>
            </div-->
            <div class="flex md12 xs12">
              <div id="divFiltroTempo">
                <multiselect id="selectSegmentoTemporal"
                  name="selectTemporal"
                  :placeholder="$t('mainDashboard.filterTablePlaceholder')"
                  :value="corteTemporalEscolhido"
                  :options="corteTemporal"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  :allowEmpty="false"
                  v-model="corteTemporalEscolhido"
                  track-by="atributo"
                  label="label"
                  @input="updateSub" />
              </div>
              <!--sp360-data-table v-if="!tabela.tableDataSecao.data.length" id="tabelaLicPorSub" ref="licPorSub" :apiMode="false" :data="tabela.tableDataSubs.data"
                :fields="tabela.tableFieldsSubs" :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" :footerObj="footerGeral" /-->

              <sp360-data-table v-if="tabela.tableDataSecao.data.length" id="tabelaSecaoPorSub" ref="secaoPorSub" :apiMode="false" :data="tabela.tableDataSecao.data"
              :fields="tabela.tableFieldsSecao" :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" :footerObj="footerSub" />

            </div>

          </div>
        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 sm12">
        <sp-360-panel  :title="tituloHorizontalBar" :tooltipOptions="barTooltipOptions" :footerText="ref">
          <sp360-chart  class="lic-chart" v-bind:data="licenciamentosBarData" :options="optionsLicenciamentoBar" type="vertical-bar" />
        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 sm12">
        <sp-360-panel  :title="tituloLineEmpresasEmpreendaIntervalo" :tooltipOptions="tooltipOptionsLineEmpresasEmpreendaIntervalo" :footerText="ref">
          <sp360-chart :data="dadosLineEmpresasEmpreendaIntervalo" type="line" class="chart" :options="optionsLineEmpresasEmpreendaIntervalo" />
        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md12 sm12">
        <sp-360-panel :title="tituloLineEmpresasIntervalo" :tooltipOptions="tooltipOptionsLineEmpresasIntervalo" :footerText="ref">
          <sp360-chart :data="dadosLineEmpresasIntervalo" type="line" class="chart" :options="optionsLineEmpresasIntervalo" />
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import constantes from '@/utils/ConstantesGlobais'
import mapaDeCalor from '@/services/MapaDeCalor'
import MethGlob from '@/utils/MetodosGlobais'
import SpMap from '@/components/maps/360-maps/SPMap'
import _ from 'lodash'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import CorUtils from '@/utils/CorUtils'
import * as d3 from 'd3'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import SpCard from '@/components/ui/cards/SP360Card'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ccm-empresas',
  components: {
    Sp360Panel,
    SpMap,
    Sp360DataTable,
    Sp360Chart,
    SpCard,
    Multiselect,
  },
  data () {
    return {
      ref: null,
      cores: {
        claro: '#f1f1fa',
        medio: '#9c9cd4',
        escuro: '#3b3b72',
      //   claro: CorUtil.getCorPorNomeSp360(CorUtil.VIOLETA_CLARO),
      //   medio: CorUtil.getCorPorNomeSp360(CorUtil.VIOLETA_MEDIO),
      //   escuro: CorUtil.getCorPorNomeSp360(CorUtil.VIOLETA_ESCURO),
      },
      coresGraficoLinha: CorUtils.getSimpleVector(),
      tooltipOptionsLineEmpresasIntervalo: {},
      optionsLineEmpresasIntervalo: {},
      dadosLineEmpresasIntervalo: {},
      tituloLineEmpresasIntervalo: this.$t('empreenda.ccm.tituloLineEmpresasAbertasIntervalo'),
      tooltipOptionsLineEmpresasEmpreendaIntervalo: {},
      optionsLineEmpresasEmpreendaIntervalo: {},
      dadosLineEmpresasEmpreendaIntervalo: {},
      tituloLineEmpresasEmpreendaIntervalo: this.$t('empreenda.ccm.tituloTabelaEmpresasAbertas'),
      barTooltipOptions: {},
      secoesFiltradas: [],
      footerGeral: {},
      footerSub: {},
      TMA: {},
      tmaCard: {},
      // subAtual: this.$t('mainDashboard.general'),
      ultimoClickIdSub: -1,
      ultimoClickNomeSub: '',
      corteTemporal: [
        {
          atributo: 'ULTIMO_MES',
          label: 'Último mês fechado',
        },
        {
          atributo: 'ULTIMO_SEMESTRE',
          label: 'Últimos 6 meses fechados',
        },
        {
          atributo: 'ULTIMO_ANO',
          label: 'Último ano',
        },
        {
          atributo: 'DESDE_SEMPRE',
          label: 'Desde Maio/2017',
        },
      ],
      corteTemporalEscolhido: {
        atributo: 'DESDE_SEMPRE',
        label: 'Desde Maio/2017',
      },
      dados: {},
      licenciamentosBarData: {},
      options: {},
      totalEmpresasUltimoMes: 0,
      totalEmpresasUltimoSemestre: 0,
      totalEmpresasUltimoAno: 0,
      totalEmpresasDesdeSempre: 0,
      secaoPorSub: [],
      tabela: {
        titulo: this.$t('empreenda.ccm.tituloTabelaEmpresasSecao'),
        tableDataSubs: {
          'data': [],
        },
        tableDataSecao: {
          'data': [],
        },
        /* tableFieldsSubs: [
          {
            name: 'nome_subprefeitura',
            title: this.$t('empreenda.tableFields.subprefeitura'),
            //width: '20%',
          },
          {
            name: 'total_licencas',
            sortField: 'total_licencas',
            title: this.$t('empreenda.tableFields.licenciamentos'),
            callback: MethGlob.thousandSeparator,
            //width: '12%',
          },
          {
            name: 'porcentagem',
            sortField: 'porcentagem',
            title: this.$t('empreenda.tableFields.porcLicenciamentos'),
            callback: MethGlob.formataPercentual,
            //width: '12%',
          },
        ], */
        tableFieldsSecao: [
          {
            name: 'secao',
            title: this.$t('empreenda.tableFields.secao'),
            // width: '20% ',
          },
          {
            name: 'total_empresas',
            sortField: 'total_empresas',
            title: this.$t('empreenda.ccm.NumeroEmpresa'), //
            callback: MethGlob.thousandSeparator,
            // width: '12%',
          },
          {
            name: 'percentual',
            sortField: 'percentual',
            title: this.$t('empreenda.ccm.PorcentagemEmpresa'), //
            callback: MethGlob.formataPercentual,
            // width: '12%',
          },
        ],

        sortFunctions: {
          'total_empresas': MethGlob.ordenaTabelaParseInt,
          'percentual': MethGlob.ordenaTabelaParseFloat,
        },

        topTooltipOptions: {
          content: this.$t('empreenda.ccm.tooltipTabelaEmpresasSecao'),
          placement: 'bottom',
        },
        itemsPerPage: 12,
      },
      tituloHorizontalBar: this.$t('empreenda.ccm.tituloBarChartPeriodoSecao'),
      optionsLicenciamentoBar: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 0,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: MethGlob.percentualLabelCallback(false, true, 'pie'),
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              callback: MethGlob.formataStringCallback(20),
            },
            display: true,
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('empreenda.ccm.eixoYNumEmpresas'),
            },
            ticks: {
              callback: (value) => MethGlob.thousandSeparator(value),
            },
          }],
        },
      },
    }
  },
  mounted () {
    this.$store.dispatch('empreenda/ccmEmpresasNoIntervalo', {})
      .then((retorno) => {
        this.populateLineCcmEmpresasChart(retorno.data.data)
      })

    this.$store.dispatch('empreenda/ccmEmpresasNoIntervalo', { dataInicio: '2017-05-01', filtrarEmpreenda: 'true', agrupamento: 'mensal' })
      .then((retorno) => {
        this.populateLineCcmEmpresasEmpreendaChart(retorno.data.data)
      })

    Promise.all(
      this.corteTemporal.map((o) => { return this.$store.dispatch('empreenda/ccmEmpresasEmpreendaPorIntervalo', { intervalo: o.atributo }) }),
    )
      .then(
        (retorno) => {
          this.fonte = retorno[0].data.sigla_orgao
          this.dataRef = new Date(retorno[0].data.data_referencia_dado)
          this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef.toLocaleDateString('pt-BR') })

          for (let i = 0; i < retorno.length; i++) {
            let o = this.corteTemporal[i]
            this.secaoPorSub[o.atributo] = retorno[i].data.data
          }
          this.totalEmpresasDesdeSempre = this.totalEmpresasDesdeSempre ? this.totalEmpresasDesdeSempre : this.secaoPorSub['DESDE_SEMPRE'].reduce((acc, curr) => acc + curr.total_empresas, 0)
          this.secaoPorSub['DESDE_SEMPRE'].unshift({ secao: 'Total', total_empresas: this.totalEmpresasDesdeSempre })
          this.totalEmpresasUltimoAno = this.totalEmpresasUltimoAno ? this.totalEmpresasUltimoAno : this.secaoPorSub['ULTIMO_ANO'].reduce((acc, curr) => acc + curr.total_empresas, 0)
          this.secaoPorSub['ULTIMO_ANO'].unshift({ secao: 'Total', total_empresas: this.totalEmpresasUltimoAno })
          this.totalEmpresasUltimoSemestre = this.totalEmpresasUltimoSemestre ? this.totalEmpresasUltimoSemestre : this.secaoPorSub['ULTIMO_SEMESTRE'].reduce((acc, curr) => acc + curr.total_empresas, 0)
          this.secaoPorSub['ULTIMO_SEMESTRE'].unshift({ secao: 'Total', total_empresas: this.totalEmpresasUltimoSemestre })
          this.totalEmpresasUltimoMes = this.totalEmpresasUltimoMes ? this.totalEmpresasUltimoMes : this.secaoPorSub['ULTIMO_MES'].reduce((acc, curr) => acc + curr.total_empresas, 0)
          this.secaoPorSub['ULTIMO_MES'].unshift({ secao: 'Total', total_empresas: this.totalEmpresasUltimoMes })
          this.updateSub()
          this.populateLicenciamentoChart()

          // :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
          // this.fonte = retorno.data.sigla_orgao + '-' + retorno.data.fonte
          // this.dataRef = new Date(retorno.data.data_referencia_dado).toLocaleDateString('pt-BR')
          // this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

        }
      )
      .catch(
        (error) => {
          console.error(error)
        })
  },
  methods: {
    updateSub () {
      this.preencherTabelaSubs(this.secaoPorSub[this.corteTemporalEscolhido.atributo])
      /* if(this.ultimoClickIdSub > 0){
          this.updateTableSecao(this.ultimoClickIdSub);
        } */
    }, /*
    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickIdSub != idNum) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.diminuirOpacidadeTodas()
        this.$refs.mapa.aumentarOpacidade(id)
        this.updateTableSecao(idNum)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
      } else {
        this.$refs.mapa.limparClick(id)
        this.$refs.mapa.aumentarOpacidadeTodas()
        //this.updateTable(0)
        this.hideSecaoTable();
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
        //this.munAtual = this.$t('mainDashboard.general')
      }
    },
    updateTableSecao(idSub){
      this.tabela.tableDataSecao.data = this.secaoPorSub[this.corteTemporalEscolhido.atributo][idSub].lista_licencas
      let x = this.secaoPorSub[this.corteTemporalEscolhido.atributo][idSub]
      let footer = {
        total_licencas: MethGlob.thousandSeparator(x.total_licencas),
        ds_secao: x.nome_subprefeitura,
      }
      this.footerSub = footer;
      this.subAtual = this.secaoPorSub[this.corteTemporalEscolhido.atributo][idSub].nome_subprefeitura
    }, */
    hideSecaoTable () {
      this.tabela.tableDataSecao.data = []
      this.subAtual = this.$t('mainDashboard.general')
    },
    criarLegenda () {
      this.$refs.mapa.definirLegenda([this.cores.claro, this.cores.escuro],
        [this.$t('mainDashboard.legendaTitulo')])
    },
    preencherTabelaSubs (data) {
      data = _.cloneDeep(data)
      this.footerSub = data.shift()
      this.footerSub.total_empresas = MethGlob.thousandSeparator(this.footerSub.total_empresas)

      this.tabela.tableDataSecao.data = []
      data = _.orderBy(data, ['total_empresas'], ['desc'])
      this.tabela.tableDataSecao.data = data

      // this.pintarRegiao(this.tabela.tableDataSubs.data)
      // this.$refs.mapa.setLegenda(data[data.length - 1].total_licencas, data[0].total_licencas, this.$t('empreenda.textoEixoLegenda.licenciamentosRegiao'), 6)
      // this.criarLegenda()
    },
    populateLicenciamentoChart (d) {
      this.licenciamentosBarData = {}
      this.licenciamentosBarData.labels = []
      this.licenciamentosBarData.datasets = []
      let x = {}

      let l = this.secaoPorSub['DESDE_SEMPRE']
      let cores = _.reverse(CorUtils.getVetorCoresPorTom('medio'))

      l.forEach(y => {
        if (y.total_empresas >= 1000) {
          x[y.secao] = 0
        } else {
          x['Outros'] = 0
          this.secoesFiltradas.push(y.secao)
        }
      })

      this.barTooltipOptions = {
        content: this.$t('empreenda.ccm.tooltipBarSecao') + this.secoesFiltradas.join('; '),
        placement: 'bottom',
      }

      this.corteTemporal.slice(0).reverse().map(o => {
        let y = _.clone(x)

        let d = this.secaoPorSub[o.atributo]

        d.forEach(obj => {
          if (Object.keys(y).includes(obj.secao)) {
            y[obj.secao] = obj.total_empresas
          } else {
            y['Outros'] += obj.total_empresas
          }
        })

        let cor = cores.shift()

        let dataset = {
          backgroundColor: cor,
          data: Object.values(y),
          label: o.label,
        }

        this.licenciamentosBarData.labels = Object.keys(y)
        this.licenciamentosBarData.datasets.push(dataset)
      })
    },
    populateLineCcmEmpresasChart (data) {
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = _.cloneDeep(this.cores)
      let labels = ''

      data = _.orderBy(data, ['ano'], ['desc'])
      /* labels = _.map(data, (r) => {
            return MethGlob.mapeiaMesAbreviacao(parseInt(r.mes)).abrev + '/' + r.ano
        }) */

      labels = _.map(data, (r) => {
        return r.ano
      })

      data = _.map(data, (r) => {
        return r.total_empresas
      })

      let corDataset = this.coresGraficoLinha.shift()
      let dataSetCcmEmpresas = {
        label: this.$t('empreenda.ccm.labelLineEmpresas'),
        fill: false,
        backgroundColor: corDataset,
        borderColor: corDataset,
        data: _.reverse(data),
        yAxisID: 'y-axis-1',
      }
      datasets.push(dataSetCcmEmpresas)

      chartData = {
        datasets: datasets,
        labels: _.reverse(labels),
      }

      options = this.getOptionsLine(false, true)

      this.tooltipOptionsLineEmpresasIntervalo = {
        content: this.$t('empreenda.ccm.tooltipLineEmpresasPorAno'),
        placement: 'bottom',
      }

      this.optionsLineEmpresasIntervalo = options
      this.dadosLineEmpresasIntervalo = chartData

      // this.dadosLineEmpresasIntervalo = data;
    },
    populateLineCcmEmpresasEmpreendaChart (data) {
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = _.cloneDeep(this.cores)
      let labels = ''

      data = _.orderBy(data, ['ano', 'mes'], ['desc', 'desc'])
      labels = _.map(data, (r) => {
        return MethGlob.mapeiaMesAbreviacao(parseInt(r.mes)).abrev + '/' + r.ano
      })

      data = _.map(data, (r) => {
        return r.total_empresas
      })

      let corDataset = this.coresGraficoLinha.shift()
      let dataSetCcmEmpreendaEmpresas = {
        label: this.$t('empreenda.ccm.labelLineEmpresas'),
        fill: false,
        backgroundColor: corDataset,
        borderColor: corDataset,
        data: _.reverse(data),
        yAxisID: 'y-axis-1',
      }
      datasets.push(dataSetCcmEmpreendaEmpresas)

      chartData = {
        datasets: datasets,
        labels: _.reverse(labels),
      }

      options = this.getOptionsLine(false, true)

      this.tooltipOptionsLineEmpresasEmpreendaIntervalo = {
        content: this.$t('empreenda.ccm.tooltipLineEmpresasEmpreendaIntervalo'),
        placement: 'bottom',
      }

      this.optionsLineEmpresasEmpreendaIntervalo = options
      this.dadosLineEmpresasEmpreendaIntervalo = chartData

      // this.dadosLineEmpresasIntervalo = data;
    },
    getOptionsLine (percentual = true, milhar = false) {
      return {
        tooltips: {
          intersect: true,
          callbacks: this.tooltipsCallback(percentual, milhar),
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: false,
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              callback: (value) => MethGlob.thousandSeparator(value),
            },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('empreenda.ccm.eixoYNumEmpresas'),
            },
          }],
        },
      }
    },
    tooltipsCallback (perc, separadorMilhar) {
      return {
        label: function (tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label + ': ' || ''
          if (separadorMilhar) { label += MethGlob.thousandSeparator(tooltipItem.yLabel) } else { label += tooltipItem.yLabel }
          if (label && perc) {
            label += '%'
          }
          return label
        },
      }
    },
    /*
    pintarRegiao(dados) {
      let c = CorUtils.getCoresMapa()
      //dados.shift()
      dados = _.orderBy(dados, ['total_licencas'], ['asc'])
      let colorScale = d3.scaleLinear()
        .domain([_.first(dados).total_licencas, _.last(dados).total_licencas])
        .range([c.claro, c.escuro])

      dados.forEach((element) => {
        let id = 'sub' + element.id_subprefeitura
        this.$refs.mapa.pintarRegiao(id, colorScale(element.total_licencas))
      })
    }, */
  },
}
</script>

<style lang="scss">
.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}

.lic-chart{
  height: 700px;
}
.chart-widget{
  max-height: 50em;
}

.va-chart{
  max-height: 50em;
}

</style>
